/* eslint-disable no-useless-escape */

import parse from 'node-html-parser';
import logger from 'src/services/logger/getLogger';

export type MagentoSliderImage = {
  href: string;
  desktop: string;
  mobile: string;
};

const defaultResult = {
  autoplay: false,
  data: [] as MagentoSliderImage[]
};

const regex = {
  autoplay: /data-autoplay="true"/g
};

export const hasMagentoSlider = (data: string) => {
  return /data-content-type=\"slider\"/gm.test(data);
};

export function getMagentoSlider(data: any) {
  if (!hasMagentoSlider(data)) {
    return defaultResult;
  }

  const contentHtml = document.createElement('div');
  contentHtml.innerHTML = String(data);
  contentHtml.querySelector('div[data-content-type="slider"]');

  const slides = contentHtml.querySelectorAll(
    '.pagebuilder-slide-wrapper[data-background-type="image"]'
  );
  // get the url of every slide
  const urls = Array.from(slides).map(slide => {
    // This fixes the issue with the JSON string having extra backslashes and
    // breaks the JSON.parse function
    // @ts-expect-error - TS doesn't know about the dataset property
    let jsonString = slide?.dataset?.backgroundImages?.replace(/\\/g, '');
    let url;

    if (jsonString) {
      try {
        let jsonObj = JSON.parse(jsonString);
        url = jsonObj;
      } catch (error) {
        // Just in case the JSON is invalid and we need to debug
        // eslint-disable-next-line no-console
        logger.error('Error parsing JSON:', error);
      }
    }
    return url;
  });

  if (urls.length > 0) {
    const validUrls = urls.filter(item => !!item);
    const maps = validUrls.map(item => {
      return {
        href: item?.hrefs ?? '',
        desktop: item.desktop_image ?? '',
        mobile: item.mobile_image ?? ''
      };
    });

    return {
      autoplay: regex.autoplay.test(data),
      data: maps
    };
  }

  return defaultResult;
}

/**
 * Get Magento slider images from server.
 * `BE CAREFUL`: This function depends on node.js and will not work in the browser
 * @param {string} data - The content to extract images from is a string of HTML
 * @returns {MagentoSliderImage} An object containing the desktop and mobile image URLs
 * if the images are not found, the URLs will be empty strings
 */
export const getMagentoSliderFromServer = (data: string) => {
  try {
    const doc = parse(data);

    const desktopImgElement = doc.querySelector(
      'img[data-element="desktop_image"]'
    );
    const mobileImgElement = doc.querySelector(
      'img[data-element="mobile_image"]'
    );

    return {
      desktop: desktopImgElement?.getAttribute('src') ?? '',
      mobile: mobileImgElement?.getAttribute('src') ?? '',
      href: doc.querySelector('a')?.getAttribute('href') ?? ''
    };
  } catch {
    return {
      mobile: '',
      desktop: '',
      href: ''
    };
  }
};

export const getDescriptionContentWithoutImages = (data: string = '') => {
  if (!data) return '';

  const doc = parse(data);

  const desktopImgElement = doc.querySelector(
    'img[data-element="desktop_image"]'
  );
  const mobileImgElement = doc.querySelector(
    'img[data-element="mobile_image"]'
  );

  if (desktopImgElement) {
    desktopImgElement.replaceWith('<span id="banner_image" />');
  }
  if (mobileImgElement) {
    mobileImgElement.replaceWith('');
  }

  return doc.toString();
};
